<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
  >
    <path d="M0 2C0 0.895431 0.89543 0 2 0H9C10.1046 0 11 0.895431 11 2V9H14V11C14 12.6569 12.6569 14 11 14H3C1.34315 14 0 12.6569 0 11V2ZM11 10V13C12.1046 13 13 12.1046 13 11V10H11ZM10 13V2C10 1.44772 9.55229 1 9 1H2C1.44772 1 1 1.44772 1 2V11C1 12.1046 1.89543 13 3 13H10ZM3 3.5C3 3.22386 3.22386 3 3.5 3H7.5C7.77614 3 8 3.22386 8 3.5C8 3.77614 7.77614 4 7.5 4H3.5C3.22386 4 3 3.77614 3 3.5ZM3 6.5C3 6.22386 3.22386 6 3.5 6H7.5C7.77614 6 8 6.22386 8 6.5C8 6.77614 7.77614 7 7.5 7H3.5C3.22386 7 3 6.77614 3 6.5ZM3 9.5C3 9.22386 3.22386 9 3.5 9H5.5C5.77614 9 6 9.22386 6 9.5C6 9.77614 5.77614 10 5.5 10H3.5C3.22386 10 3 9.77614 3 9.5Z" />
  </svg>
</template>